import { ChangeDetectorRef, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SubscribedContainer } from '../../util/subscribed-container';
import { IBaryInput } from '../../../../models/bary-input';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { Address } from '../../../../models/address.model';
import { AddressFormGroup } from '../../../../models/forms/AddressFormGroup';
import { BillAddressFormGroup } from '../../../../models/forms/BillAddressFormGroup';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { GooglePlacesDirective } from '../../../../directives/google-places.directive';

@Component({
  selector: 'jhi-bary-input-gplace',
  standalone: true,
  imports: [GooglePlacesDirective, ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective],
  templateUrl: './bary-input-gplace.component.html',
  styleUrls: ['./bary-input-gplace.component.scss'],
})
export class BaryInputGplaceComponent extends SubscribedContainer implements OnInit, OnChanges, IBaryInput {
  readonly #cdr = inject(ChangeDetectorRef);

  @Input() id = '';
  @Input() label?: string;
  @Input() icon?: string;
  @Input() name?: string;
  @Input() class = '';
  @Input() disabled = false;
  // activer ou non la verification du contenu de l'adresse
  @Input() verify = true;
  @Input() addressForm!: AddressFormGroup | BillAddressFormGroup;
  @Input() touched = false;

  control: FormControl = new FormControl();
  validAddress = false;

  setAddress(address: Address): void {
    this.addressForm.updateForm(address);
    this.control.setValue(this.addressForm.controls.autofill.value);
    this.validAddress = true;
    this.#cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (change === 'touched' && changes['touched'].currentValue) {
        this.control.markAsTouched();
      }
    }
  }

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.control.setValue(this.addressForm.controls.autofill.value);

    this.addressForm.controls.autofill.valueChanges.subscribe(() => {
      this.control.setValue(this.addressForm.controls.autofill.value);
    });

    if (this.verify) {
      this.control.markAsTouched();
    }
  }

  get isAddressValid(): boolean {
    return this.addressForm.controls.street.valid && this.addressForm.controls.zipCode.valid && this.addressForm.controls.country.valid;
  }
}
